
import InfiniteLoading from 'vue-infinite-loading';

import {
  copyObject,
  nestedObjectToArray,
} from '../../common/functions/helpers';

export default {
  props: {
    tableRows: {
      type: Array,
      default() { return []; },
    },
    tableHeader: {
      type: Array,
      default() { return []; },
    },
    title: {
      type: String,
      default() { return ''; },
    },
    visibleColumns: {
      type: Array,
      required: false,
      default() { return []; },
    },
    numericColumns: {
      type: Array,
      default() { return []; },
    },
    timestampColumns: {
      type: Array,
      default() { return []; },
    },
    mobileInvisibleColumns: {
      type: Array,
      default() { return []; },
    },
    ignoreColumns: {
      type: Array,
      default() { return []; },
    },
    lastSearchTableSize: {
      type: Number,
      default() { return null; },
    },
  },
  data() {
    return {
      ignoredColumns: [],
      tableData: [],
      columnTypes: [],
      currentColumn: '',
      currentEditItem: null,
      editItem: null,
      edition: null,
      selected: null,
      showLoading: false,
      paginationSize: 20,
      searchQuery: '',
      dialog: {
        ref: 'dialog1',
        from: 'blockbtn',
        title: 'Atenção',
        content: 'Deseja realmente aplicar esta ação',
        action: () => ({}),
      },
      sortData: { name: 'dessert', type: 'desc' },
      openSearchToolbar: false,
      paginationPage: 0,
      stopRequestingPages: false,
      blockExportButton: false,
    };
  },
  computed: {
    isHeaderAvailable() {
      return this.tableHeader && this.tableHeader.length;
    },
    isContentAvailable() {
      return !!this.filteredList && !!this.filteredList.length;
    },
    canRenderTable() {
      return this.isHeaderAvailable && this.isContentAvailable;
    },
    filteredList() {
      if (this.tableData) {
        if (this.searchQuery.length > 2) {
          return this.filterDatasource();
        }
      }
      return this.tableData;
    },
    selectedRowElements() {
      if (this.$refs.myTable) {
        return (this.filteredList.length < this.$refs.myTable.numberOfSelected) ?
          this.filteredList.length :
          this.$refs.myTable.numberOfSelected;
      }
      return 0;
    },
  },
  components: {
    InfiniteLoading,
  },
  watch: {
    tableRows(newVal) {
      this.tableData = (newVal) ?
        copyObject(newVal) :
        [];

      if (this.lastSearchTableSize) {
        this.closeLoading(false);
        if (this.paginationSize > this.lastSearchTableSize) {
          this.closeLoading(true);
        }
      }
    },
  },
  methods: {
    ativarInativarSelecao() {
      const selected = this.getTableSelection();
      this.selected = null;
      this.$refs.myTable.numberOfSelected = 0;
      this.currentEditItem = null;
      this.$emit('TABELAGENERICA_BLOQUEAR_SELECIONADOS', selected);
    },
    blockSelectedItems() {
      this.ativarInativarSelecao();
    },
    selecionadoLabel() {
      return this.$refs.myTable && this.$refs.myTable.numberOfSelected > 1 ? 'selecionados' : 'selecionado';
    },
    cleanEdition() {
      this.edition = '';
      this.currentColumn = '';
      this.currentEditItem = null;
      this.editItem = null;
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    closeSearchHeader() {
      this.searchQuery = '';
      this.openSearchToolbar = false;
    },
    closeLoading(stop = null) {
      if (stop) {
        this.stopRequestingPages = true;
      } else {
        this.stopRequestingPages = false;
      }

      this.showLoading = false;

      if (this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
      }
    },
    countSelectedItems() {
      return this.selected ?
        nestedObjectToArray(this.selected)
          .filter(el => typeof el !== 'undefined')
          .length :
          0;
    },
    exportData() {
      this.blockExportButton = true;
      this.$emit('TABELAGENERICA_EXPORTAR_DADOS',
        () => { this.blockExportButton = false; });
    },
    filterDatasource(array) {
      const filtered = (array || this.tableData).filter((el) => {
        const auxa = Object.keys(el).map((key) => {
          const entry = el[key];
          return (typeof entry === 'object') ?
            JSON.stringify(entry).toLowerCase() :
            entry.toString().toLowerCase();
        });
        const result = auxa.filter(elem => ~elem.indexOf(this.searchQuery.toLowerCase())); // eslint-disable-line
        return result.length > 0;
      });
      return filtered;
    },
    focusSearchInput(id) {
      this.openSearchToolbar = true;
      setTimeout(() => {
        const input = document.getElementById(id);
        input.focus();
      }, 100);
    },
    getEditDependency(column, rowAccess, dependency) {
      return (typeof column === 'object') ?
        rowAccess[dependency] :
        rowAccess;
    },
    getTableSelection() {
      const mapSelectedIds = this.selected
        .map(el => el.id);
      const mapped = this.tableData
        .map((el, index) => {
          if (mapSelectedIds.indexOf(el.id) !== -1) {
            return index;
          }
          return undefined;
        });
      const filtered = mapped.filter(el => el !== undefined);
      return filtered;
    },
    hideOnMedium(columnIndex) {
      return this.mobileInvisibleColumns.indexOf(columnIndex) !== -1;
    },
    isAccepted(col) {
      return !this.ignoredColumns.length || this.ignoredColumns.indexOf(col) === -1;
    },
    isColumnVisible(column) {
      return this.visibleColumns.indexOf(column) !== -1;
    },
    isNumericField(columnIndex) {
      return this.numericColumns.indexOf(columnIndex) === -1;
    },
    isTimestampField(columnIndex) {
      return this.timestampColumns.indexOf(columnIndex) === -1;
    },
    moveOnNextTableData(col, row = null) {
      this.editItem = row || this.editItem;
      this.currentEditItem = row || this.currentEditItem;
      this.currentColumn = col;
      this.edition = this.editItem ?
        this.editItem[col].toString() :
        '';

      this.setFocusOnInput();
    },
    onArrowDownPress() {
      this.previousNextRowSelector('next');
    },
    onArrowUpPress() {
      this.previousNextRowSelector('prev');
    },
    onCelMouseEnter(row, col) {
      if (!this.currentEditItem) {
        this.editItem = row;
        this.currentColumn = col;
      }
    },
    onCelMouseLeave() {
      if (!this.currentEditItem) {
        this.currentEditItem = null;
        this.editItem = null;
      }
    },
    onClickEdit(row, value, inputId = null) {
      if (this.onClickEditSpecific) {
        this.onClickEditSpecific(row);
      }
      this.currentEditItem = row;
      this.edition = value;

      this.setFocusOnInput(inputId);
    },
    onInfinite() {
      if (this.stopRequestingPages) {
        return;
      }

      this.showLoading = true;
      this.paginationPage += 1;

      const pagination = {
        size: this.paginationSize,
        page: this.paginationPage,
        filter: this.searchQuery,
      };
      if (this.hasOwnProperty('statusFilter') && this.statusFilter !== '') {
        pagination.indAtivo = this.statusFilter;
      }

      this.$emit('TABELAGENERICA_BUSCAR_PROXIMA_PAGINA', pagination, this.closeLoading);
    },
    onKeyCtrlAPress() {
 // eslint-disable-line
    },
    onKeyEnterPress() {
      this.cleanEdition();
    },
    onKeyEscPress() {
      this.cleanEdition();
    },
    onOpen() {
 // eslint-disable-line
    },
    onSelect(obj) {
      this.select(this.filteredList, obj, true);
    },
    setList(list, obj, param) {
      if (param) {
        return (list.length === this.tableData.length) ?
          Object.keys(obj).map(el => this.tableData[el]).filter(el => typeof el !== 'undefined') :
          this.filteredList;
      }
      return Object.keys(obj).map(el => this.tableData[el]).filter(el => typeof el !== 'undefined');
    },
    clearCheckbox() {
      this.selected = [];
      const parent = this.$refs.myTable ? this.$refs.myTable.$children : undefined;
      if (parent) {
        parent.forEach((row, index) => {
          if (parent[index].$children[0]) {
            parent[index].checkbox = false;
            parent[index].$children[0].$children[0].checked = false;
          }
        });
        parent[0].checkbox = false;
        parent[0].$children[parent[0].$children.length - 1].$children[0].checked = false;
      }
    },
    select(list, obj, param) {
      this.selected = this.setList(list, obj, param);

      this.$nextTick(() => {
        if (document.querySelector('.md-counter span:first-child')) {
          document.querySelector('.md-counter span:first-child').innerHTML = this.selected.length;
        }
      });
      const parent = this.$refs.myTable.$children;
      if (this.selected.length === this.tableData.length || this.selected.length === 0) {
        const value = parent[0].checkbox;
        parent.forEach((row, index) => {
          if (parent[index].$children[0]) {
            parent[index].checkbox = value;
            parent[index].$children[0].$children[0].checked = value;
          }
        });
      }
      if (this.selected.length === this.tableData.length) {
        parent[0].checkbox = true;
        parent[0].$children[parent[0].$children.length - 1].$children[0].checked = true;
        if (this.tableData.length === 1) {
          parent.forEach((row, index) => {
            if (parent[index].$children[0]) {
              parent[index].checkbox = true;
              parent[index].$children[0].$children[0].checked = true;
            }
          });
        }
      } else {
        parent[0].checkbox = false;
        parent[0].$children[parent[0].$children.length - 1].$children[0].checked = false;
      }
    },
    onSort(obj) {
      this.sortData = obj;
      this.$emit('TABELAGENERICA_ORDENAR', this.sortData);
      this.cleanEdition();
    },
    onTabPress() {
      const keys = Object.keys(this.currentEditItem),
        colIndex = keys.indexOf(this.currentColumn),
        currentEditItemIndex = this.tableData.indexOf(this.currentEditItem),
        lastColumnIndex = keys.length - 1,
        lastTableRow = this.tableData.length - 1;

      if (colIndex === lastColumnIndex || colIndex === -1) {
        const nextRow = (currentEditItemIndex === lastTableRow) ?
          this.tableData[0] :
          this.tableData[currentEditItemIndex + 1];
        const nextRowKeys = Object.keys(nextRow),
          col = nextRowKeys[0];
        this.moveOnNextTableData(col, nextRow);
        if (!this.isAccepted(col)) {
          this.onTabPress();
        }
        return;
      }
      const col = keys[colIndex + 1];
      this.moveOnNextTableData(col);
      if (!this.isAccepted(col)) {
        this.onTabPress();
      }
    },
    openBlockDialog(ref, from) {
      const content = `Deseja ativar/inativar o(s) ${this.selectedRowElements} elemento(s) selecionado(s)?`;
      this.setDialogContent(content, this.blockSelectedItems, from);

      const parent = this.$refs.myTable.$children;
      parent.forEach((row, index) => {
        if (parent[index].$children[0]) {
          parent[index].checkbox = false;
          parent[index].$children[0].$children[0].checked = false;
        }
      });
      parent[0].checkbox = false;
      parent[0].$children[parent[0].$children.length-1].$children[0].checked = false;// eslint-disable-line
      this.openDialog(ref);
    },
    openDialog(ref) {
      this.$refs[ref].open();
    },
    previousNextColumnSelector() {},
    previousNextRowSelector(direction) {
      if (this.currentEditItem) {
        const nextRow = this.rowSelection(direction),
          column = this.currentColumn || Object.keys(nextRow)[0];

        this.moveOnNextTableData(column, nextRow);
        return;
      }
      const index = (direction === 'next') ? 0 : this.tableData.length - 1,
        row = this.tableData[index];
      this.moveOnNextTableData(Object.keys(row)[0], row);
    },
    rowSelection(direction) {
      const currentIndex = this.tableData.indexOf(this.currentEditItem);
      let nextRow = null;
      if (direction === 'next') {
        nextRow = (currentIndex === this.tableData.length - 1) ?
          this.tableData[0] :
          this.tableData[currentIndex + 1];
      } else {
        nextRow = (currentIndex === 0) ?
          this.tableData[this.tableData.length - 1] :
          this.tableData[currentIndex - 1];
      }

      return nextRow;
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content;
      this.dialog.action = action;
      this.dialog.from = from;
    },
    setFocusOnInput(inputId) {
      let target = null;

      if (inputId === null) {
        if (!this.$refs.currentinput ||
          !this.$refs.currentinput.length) {
          return;
        }
        const currInput = this.$refs.currentinput[0];
        target = currInput.focus ?
          currInput :
          currInput.$el;
      } else {
        target = document.getElementById(inputId);
      }

      setTimeout(() => target.focus(), 500);
    },
    startComponent() {
      this.tableData = copyObject(this.tableRows);
      this.ignoredColumns = copyObject(this.ignoreColumns);
      this.onInfinite();
    },
    updateItemDependency(row, property, dependency) {
      const item = Object.assign({}, row);
      item[property] = dependency;
      this.$emit('TABELAGENERICA_ATUALIZAR', item);
      this.cleanEdition();
    },
    updateItem(row, rowIndex, columnIndex) {
      const item = Object.assign({}, row);
      if (this.edition !== null && this.edition !== undefined) {
        if (typeof this.edition !== 'object') {
          const newVal = this.edition.toString();
          if (columnIndex && item[rowIndex]) {
            item[rowIndex][columnIndex] = newVal;
          } else if (item[rowIndex]) {
            item[rowIndex] = newVal;
          }
        }
      }

      this.$emit('TABELAGENERICA_ATUALIZAR', item);
      this.cleanEdition();
    },
  },
  mounted() {
    this.startComponent();
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/generico/TabelaGenerica.vue?vue&type=script&lang=js&